import React from 'react';
import appStyles from "../../utils/styles";
import OverflowImages from "../OverflowImages";

const DescriptionOverflowImages = props => {
    const {title, images, maxCount} = props;
    return (
        <div style={{...appStyles.row, alignItems: 'center'}}>
            <div style={{...appStyles.row, alignItems: 'center', marginRight: 4}}>
                <OverflowImages images={images} maxCount={maxCount} size={40}/>
            </div>
            <p style={{fontWeight: '600', fontSize: 18, margin: 0}}>{title}</p>
        </div>
    )
}

export default DescriptionOverflowImages;
